import React, { useEffect, useState, useContext, useRef } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import Select from "../Objects/Select.js";
import useLocalStorage from "../Utility/useLocalStorage.js";
import Breadcrumb from "../Layout/Breadcrumb";

// import TabellaFascicolo from '../Objects/TabellaFascicolo'
import Repo from "../Utility/Repo";

import AlertMessage from "../Objects/AlertMessage";
import { useCookies } from "react-cookie";
import TabellaFascicolo from "../Objects/TabellaFascicolo";

import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

import Notification from "../Objects/Notification.js";
import ListaConnettoriErrore from "../Objects/ListaConnettoriErrore.js";

function Fascicolo(props) {
  //STATE E COSTANTI
  /* #region   STATE*/
  const myRefDiv = useRef(null);
  const [cookies] = useCookies();
  const [apiToken] = useState(cookies.api_token);
  const [loading, setLoading] = useState();
  const [fascicolo, setFascicolo] = useState([]);
  const [errorFlag, setErrorFlag] = useState(false);

  const [entrysList, setEntrysList] = useState([
    {
      value: "0",
      label: "Tutti",
    },
  ]);
  const [yearsList, setYearsList] = useState([
    {
      value: "0",
      label: "Tutti",
    },
  ]);

  const [responseFascicolo, setResponseFascicolo] =
    useLocalStorage("responseFascicolo");
  const [bkFascicolo, setBkFascicolo] = useLocalStorage("BkFascicolo");
  const [items, setItems] = useState([]);
  const [filterFascicolo, setFilterFascicolo, removeFilterFascicolo] =
    useLocalStorage("FilterFascicolo");
  const [data, setData] = useState({
    CFPIva: "",
  });
  /* #endregion */
  /* #region  CONST PAGINAZIONE */
  const [pageIndex, setPageIndex] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [resetPag, setResetPag] = useState(true);
  const [itemsPerPage] = useState(4);
  const [itemOffset, setItemOffset] = useState(0);
  const [pageFascicolo, setPageFascicolo] = useLocalStorage("PageFasicolo");

  const [listEelementsInError, setListEelementsInError] = useLocalStorage("ListError");
  const [disableNotifications, setDisableNotifications] = useState(false);

  /* #endregion */

  //USEEFFECT
  /* #region  USEEFFECT */

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setFascicolo(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items]);

  const reload = (dataJson) => {
    setLoading(false);
    Repo.getFascicolo(apiToken, dataJson)
      .then((response) => {
        setItems(response.data.items);
        setListEelementsInError(response.data.connectorErrors)
        setFilter(response.data.items);
        setFascicolo(items.slice(0, itemsPerPage));
        setResponseFascicolo(response.data.items);
        setLoading(true);
        setErrorFlag(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
        setErrorFlag(true);
      });
  };

  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  useEffect(() => {
    if (props.codiceFiscale) {
      var dataObb = data;
      dataObb.CFPIva = props.codiceFiscale;
      var dataJson = JSON.stringify(dataObb);
      setData(dataObb);

      if (bkFascicolo) {
        setLoading(true);
        setPageIndex(pageFascicolo);
        setItems(bkFascicolo);
        setFascicolo(bkFascicolo.slice(0, itemsPerPage));

        setFilter(responseFascicolo);
      } else {
        if (responseFascicolo && responseFascicolo.length > 0) {
          setLoading(true);
          setPageIndex(pageFascicolo);
          setItems(responseFascicolo);
          setFascicolo(responseFascicolo.slice(0, itemsPerPage));
          setFilter(responseFascicolo);
        } else reload(dataJson);
      }

      if (filterFascicolo) {
        setData(filterFascicolo);
      }
    }
  }, [props.codiceFiscale]);

  useEffect(() => {
    const newOffset = (0 * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    setResetPag(true);
  }, [bkFascicolo]);

  useEffect(() => {
    const newOffset = (0 * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    setResetPag(true);
  }, [responseFascicolo]);

  /* #endregion */

  // FUNZIONI
  /* #region  FUNZIONI */
  const handleChange = (event) => {
    var value = event.target.value;
    switch (event.target.name) {
      case "valueDateEmmision":
        setData((prevState) => ({
          ...prevState,
          AnnoImposta: value,
        }));
        break;

      case "valueTaxYear":
        setData((prevState) => ({
          ...prevState,
          AnnoEmissione: value,
        }));
        break;

      default:
        break;
    }
  };
  const handleChangeSelect = (event, nameOfComponent) => {
    let name = nameOfComponent.name;
    let value = event.value;

    switch (name) {
      case "valueDataEntry":
        setData((prevState) => ({
          ...prevState,
          TipoEntrata: event.value,
          LabelEntrata: event.label,
        }));
        break;

      case "annoEmmisione":
        setData((prevState) => ({
          ...prevState,
          AnnoEmissione: event.value,
        }));
        break;
      default:
        break;
    }
  };
  const handleSubmit = () => {
    setPageIndex(0);

    if (data.TipoEntrata !== "0" && data.AnnoEmissione !== 0) {
      setResetPag(false);
    }

    var tempItemFilter = responseFascicolo;

    if (data.TipoEntrata && data.TipoEntrata != 0) {
      tempItemFilter = tempItemFilter.filter(
        (word) => parseInt(word.entrateOrganizzazioni_Id) == data.TipoEntrata
      );
    }

    if (data.AnnoEmissione && data.AnnoEmissione > 0) {
      tempItemFilter = tempItemFilter.filter(
        (word) =>
          new Date(word.dataEmissioneCartella).getFullYear() ==
          data.AnnoEmissione
      );
    }



    setItems(tempItemFilter);
    setFascicolo(tempItemFilter.slice(0, itemsPerPage));
    setBkFascicolo(tempItemFilter);

    setFilterFascicolo(data);


    myRefDiv.current.scrollIntoView();
  };
  const ResetSubmit = () => {
    setLoading(false);
    setData({
      LabelEntrata: "",
      TipoEntrata: "",
      AnnoImposta: "",
      AnnoEmissione: "",
    });
    removeFilterFascicolo();
    setPageIndex(0);
    setResetPag(false);
    var tempItemFilter = responseFascicolo;
    setItems(tempItemFilter);
    setFascicolo(tempItemFilter.slice(0, itemsPerPage));
    setBkFascicolo(tempItemFilter);

    location.reload();
  };
  const handlePageClick = (event) => {
    setPageFascicolo(event.selected);
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  const setFilter = (responseElements) => {

    var itemsInError = responseElements
      .filter((x) => x.erroreConnessione !== null)
      .map((x) => {
        return x.idTipoEntrata;
      });


    if (responseElements && responseElements.length > 0) {
      var arrayUniqueByKey = [
        ...new Map(
          responseElements.map((item) => [
            item["idTipoEntrata"],
            item["tipoEntrata"]
          ])
        ),
      ];



      var listElementEntrys = [
        {
          value: "0",
          label: "Tutti",
        },
      ];



      arrayUniqueByKey.map((x) => {

        if (!itemsInError.includes(x[0])) {

          listElementEntrys.push({
            value: x[0],
            label: x[1],
          });
        }

      });

      setEntrysList(listElementEntrys);
      var listElementYears = [];

      var listYears = [];
      responseElements.map((items) => {
        var year = new Date(items.dataEmissioneCartella).getFullYear();

        if (!listYears.includes(year) && year != 0) {
          listYears.push(year);
        }
      });

      listYears.map((x) => {
        listElementYears.push({
          value: x,
          label: x,
        });
      });

      listElementYears = listElementYears.sort(
        (a, b) => parseInt(b.value) - parseInt(a.value)
      );

      listElementYears.unshift({
        value: 0,
        label: "Tutti",
      });

      setYearsList(listElementYears);
    }
  };




  useEffect(() => {
    setTimeout(() => {
      setDisableNotifications(true)
    }, 19000);

  }, [listEelementsInError]);



  /* #endregion */

  return (
    <>
      <>
        {" "}
        {errorFlag && (
          <AlertMessage
            error={true}
            messaggio={
              "Alcuni dati potrebbero essere visualizzati non correttamente"
            }
          ></AlertMessage>
        )}


        {
          !disableNotifications && listEelementsInError && listEelementsInError.length > 0 && (

            // listEelementsInError.map((obbj, index) => <>
            <Notification
              style={{ zIndex: "500" }}

             
              header={ "Non è stato possibile recuperare" +  (listEelementsInError.length.length > 1 ? + listEelementsInError.length + " tipi di cartella" : " un tipo di cartella")}
              state="warning"
              withIcon
              dismissable={true}
             
            >
              <>
              <ul>
                {listEelementsInError.map((obbj, index) => (
                  <li key={index}>{obbj.tipoEntrata}</li>
                ))}
              </ul></>
            </Notification>
          )
          // /></>)
        }
        <div className="col-12">
          {/* FILTRI --------------------------------*/}
          <div className="card card-teaser rounded shadow mb-2">
            <div className="card-body">
              <h3>Fascicolo Personale</h3>

              <br />

              <div>
                <div>
                  <div className="form-row mb-4">
                    <div className="col-lg-9 mb-4">
                      <div className="bootstrap-select-wrapper">
                        <label>Tipo Entrata</label>
                        <Select
                          aria-label="Scegli una opzione"
                          clearText="Annulla"
                          // value={{ label: data.LabelEntrata, value: data.TipoEntrata }}
                          defaultMenuIsOpen={false}
                          icon={false}
                          name="valueDataEntry"
                          onChange={handleChangeSelect}
                          options={entrysList}
                          placeholder={
                            data.LabelEntrata ? data.LabelEntrata : "Tutti"
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group col-lg-3 ">
                      {" "}
                      <div className="bootstrap-select-wrapper">
                        <label>Anno Emissione</label>
                        <Select
                          aria-label="Scegli una opzione"
                          clearText="Annulla"
                          // value={{ label: data.LabelEntrata, value: data.TipoEntrata }}
                          defaultMenuIsOpen={false}
                          icon={false}
                          name="annoEmmisione"
                          onChange={handleChangeSelect}
                          options={yearsList}
                          placeholder={
                            data.AnnoEmissione ? data.AnnoEmissione : "Tutti"
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group col text-center">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Cerca{" "}
                      </button>

                      {/* <button
                        type="submit"
                        className="btn btn-danger ml-5"
                        onClick={() => ResetSubmit()}
                      >
                        Reset{" "}
                      </button> */}
                    </div>


                  </div>
                </div>

                {listEelementsInError && listEelementsInError.length > 0 &&

                  <div><ListaConnettoriErrore listItems={listEelementsInError} /></div>

                }



              </div>
            </div>
          </div>

          {/* FINE FILTRI --------------------------------*/}

          {resetPag && (
            <div ref={myRefDiv}>
              {loading ? (
                <TabellaFascicolo table={true} errorControll={setErrorFlag}>
                  {fascicolo}
                </TabellaFascicolo>
              ) : (
                <div className="col-12">
                  <div className="trasparente">
                    <div className="progress-spinner progress-spinner-active spinner">
                      <span className="sr-only">Caricamento...</span>
                    </div>
                  </div>
                </div>
              )}

              {fascicolo && fascicolo.length !== 0 && (
                <ReactPaginate
                  previousLabel={
                    <svg className="icon icon-primary">
                      <use xlinkHref={`${iconSprite}#it-chevron-left`}></use>
                    </svg>
                  }
                  nextLabel={
                    <svg className="icon icon-primary">
                      <use xlinkHref={`${iconSprite}#it-chevron-right`}></use>
                    </svg>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={4}
                  onPageChange={(event) => handlePageClick(event)}
                  containerClassName={
                    "pagination justify-content-center col-12"
                  }
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                  initialPage={pageIndex}
                />
              )}
            </div>
          )}
        </div>
      </>
    </>
  );
}

export default Fascicolo;
